//GeneratorFlag:[NoChange]
import ProductGroup from './product-group';

export default {ProductGroup}
export{ProductGroup}